import React, { useState, useEffect } from 'react'

//Node Modules
import {
  BrowserRouter as Router,
  Switch,
  Route
} from 'react-router-dom'
import ReactGA from 'react-ga'
import ReactGA4 from 'react-ga4'

//Pages
import ContentPage from 'pages/ContentPage'
import DownloadPage from 'pages/DownloadPage'
import NotFoundPage from 'pages/NotFoundPage'

//Context
import { InfoContext } from 'context/info-context'
import { ThemeContext } from 'context/theme-context'
import { TitleProvider } from 'context/title-context'

//Api
import { info } from 'api/info'

//Types
import Info from 'types/info'

//Util
import { INVERT_COLORS, THEME_CLASSIC, THEME_INVERTED } from 'util/constants'

//Hooks
import { useLocalStorage } from 'hooks'

//Fonts
import '@sas/filament-fonts/anova-ui/AnovaUI-Bold.woff2';
import '@sas/filament-fonts/anova-ui/AnovaUI-BoldItalic.woff2';
import '@sas/filament-fonts/anova-ui/AnovaUI-Italic.woff2';
import '@sas/filament-fonts/anova-ui/AnovaUI-Light.woff2';
import '@sas/filament-fonts/anova-ui/AnovaUI-LightItalic.woff2';
import '@sas/filament-fonts/anova-ui/AnovaUI-Regular.woff2';

import '@sas/filament-fonts/anova/Anova-Bold.woff2';
import '@sas/filament-fonts/anova/Anova-BoldItalic.woff2';
import '@sas/filament-fonts/anova/Anova-Italic.woff2';
import '@sas/filament-fonts/anova/Anova-Light.woff2';
import '@sas/filament-fonts/anova/Anova-LightItalic.woff2';
import '@sas/filament-fonts/anova/Anova-Regular.woff2';

function App() {
  const [appInfo, setAppInfo] = useState<Info | undefined>(undefined)
  const [invertColors, setInvertColors] = useLocalStorage<boolean>(INVERT_COLORS, false)

  const toggleInvertColors = () => setInvertColors(!invertColors)
  const isIE11 =  !!window.MSStream;

  const basename = isIE11 ?  document.getElementsByTagName('base')[0].href.replace(window.location.origin, '') : document.baseURI?.replace(window.location.origin, '')

  const initUrl = window.location.href
  
  let replace = initUrl.indexOf('/.htm#')
  if (replace > -1) {
    let replaceUrl  = initUrl.replace('/.htm#', '/')
    window.location.replace(replaceUrl)
  }

  useEffect(() => {
    info().then(appInfo => {
      setAppInfo(appInfo)

      ReactGA.initialize(appInfo.googleAnalytics)
      ReactGA4.initialize(appInfo.googleAnalytics4)

      const url = `${window.location.pathname}${window.location.search}`
      ReactGA.pageview(url)
      ReactGA4.send(url)
    })
  }, [])

  useEffect(() => {
    window.document.body.className = invertColors ? THEME_INVERTED : THEME_CLASSIC
  }, [invertColors])

  return (
    <>
      <TitleProvider>
      <ThemeContext.Provider value={{invertColors, toggleInvertColors}}>
        <InfoContext.Provider value={appInfo}>
          <Router basename={basename}>
            <Switch>
              {/* Downloads Page*/}
              <Route exact path="/download" component={DownloadPage} />


              {/* Collection */}
              <Route exact path="/doc/:lang/:collection/:cfr/:cdc/:docset/:page" component={ContentPage} />
              {/* CDC */}
              <Route exact path="/doc/:lang/:cdc/:cfr/:docset/:page" component={ContentPage} />
              {/* Docset */}
              <Route exact path="/doc/:lang/:docset/:cfr/:page" component={ContentPage} />
              
              
              {/* Default - Page Not Found */}
              <Route path="/" component={NotFoundPage} />
            </Switch>
          </Router>
        </InfoContext.Provider>
      </ThemeContext.Provider>
      </TitleProvider>
    </>
  )
}

export default App
